<template>
  <div class="query-page">
    <div class="mail-query">
      <div class="mail-item">
        <!-- 扫一扫 -->
        <i
          class="scan-input iconfont icon-tubiao_saoyisao_huiyuanchuzhikazhifuye"
          @click="_checkScan"
        ></i>
        <!-- 邮件号查询 -->
        <input
          v-model.trim="searchVal"
          :maxlength="mailInput.maxlength"
          :placeholder="mailInput.placeholder"
          @keyup.enter="seachCheck(searchVal)"
          type="text"
          @focus="isshowTips=false"
          @blur="changeShowTips()"
        />
        <img
          v-show="searchState"
          @click="searchVal = ''"
          class="close"
          src="@/assets/img/close.png"
          alt="scan"
        />
      </div>
      <span v-show="searchState" class="confirm-btn" @click="seachCheck(searchVal)">确定</span>
    </div>

    <div class="mail-list" >
      <!-- 历史记录 -->
      <div v-if="showState===1">
        <div class='mail-history'>
          <div
            class="mail-list-item"
            v-for="(item, index) in mailInput.mailList"
            v-show="index < 5||(index>=5&&showAllLocList)"
            :key="index"
          >
            <span v-text="item" @click="seachCheck(item)"></span>
            <img
              class="close"
              src="@/assets/img/close1.png"
              @click="handleDelMailItem(index, item)"
              alt="close"
            />
          </div>
        </div>
         <div class="mail-list-last" v-if="mailInput.mailList.length > 5">
            <span v-show="!showAllLocList" @click="showAllLocList = !showAllLocList">查看全部</span>
            <span v-show="showAllLocList" @click="showAllLocList = !showAllLocList">收起</span>
          </div>
      </div>
      <div v-else class="mail-list-center">
        <div class="not-page" :style="{'background-color':showState===-1?'#fff':'#F9F9F9'}">
          <!-- 非优先邮 -->
          <div v-if="showState===2">
            <img class="not-page-img" src="../../assets/img/not-page.png" alt />
            <div class="not-page-msg">{{mailInput.noMailMsg[0]}}</div>
            <div class="not-page-msg">{{mailInput.noMailMsg[1]}}</div>
          </div>
          <!-- 查无物流信息 -->
          <div v-else-if="showState===3">
            <img class="not-page-img" src="../../assets/img/not-content.svg" alt />
            <div :class="['not-page-msg','color-gray']" >{{mailInput.noMailMsg[2]}}</div>
          </div>
          <!-- 什么都不展示，只有背景图片 -->
          <div v-else-if="showState===-1">
            <img class="not-page-img2" src="../../assets/img/1561728035.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="tips" v-show='isshowTips'>
      中国邮政速递物流客服:
      <a href="tel: 11183">020-11183</a>
    </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'
import { isAndroid, isWX } from '@/plugin/checkBrowser/checkBrowser.js'
import doWxConfig from '@/plugin/wxConfig'
import { getQueryMailDetail } from '../components/queryMailApi'

export default {
  data () {
    return {
      searchVal: '',
      searchState: false, // true:展示确定按钮+close图标
      mailInput: {
        // value: '',
        placeholder: '请输入邮件号',
        maxlength: '13',
        mailList: [], // 历史记录
        noMailMsg: ['当前邮件非优先邮', '请前往邮政速递便民通公众号查询', '邮件查无物流信息']
      },
      showState: -1, // -1:什么都不展示,1:展示历史记录，2:不是优先邮,3:查无物流信息
      showAllLocList: false, // true:展示全部历史记录，false:只展示五个
      isshowTips: true // 防止跟随键盘显示隐藏，上下移动
    }
  },
  watch: {
    searchVal (val) {
      this.searchState = !!val.length
      this.showState = this.mailInput.mailList.length ? 1 : -1
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.path.includes('/queryDetail')) {
        vm.searchVal = ''
      }
    })
  },
  created () {
    // 初始化邮件号历史列表
    if (!localStorage.mailList || localStorage.mailList === '[]') {
      localStorage.mailList = JSON.stringify([])
      this.showState = -1
    } else {
      this.mailInput.mailList = JSON.parse(localStorage.mailList)
      this.showState = 1
    }
  },
  methods: {
    changeShowTips () {
      setTimeout(this.isshowTips = true, 3000)
    },
    // 扫一扫
    _checkScan () {
      let self = this
      const expReg = /^E[A-Z][0-9]{9}CN$/
      if (isWX()) { // 微信环境的扫一扫
        if (isAndroid()) {
          doWxConfig()
        }
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            let result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
            let temp = result.split(',')
            let code = temp[temp.length - 1]
            if (!expReg.test(code)) {
              Toast('请扫描正确的条形码')
            } else {
              self.searchVal = code
              self.seachCheck(code)
            }
          },
          error: function (res) {
            Toast('扫码失败')
          }
        })
      }
    },
    // 搜索邮件订单号
    async seachCheck (val) {
      this.searchVal = val
      this.showState = -1
      if (
        (!typeof val === 'string' && !val.replace(/^\s*|\s*$/g, '')) ||
        !val
      ) {
        this.searchVal = ''
        this.searchState = false
        return Toast('请输入搜索内容')
      }
      this.searchState = true // input框有值，展示searchState
      val = val.toUpperCase() // 将邮件号英文字母小写转换成大写
      if (!(/^E[A-Z][0-9]{9}CN$/).test(val)) { // 判断邮件输入格式
        this.showState = 2
      } else {
        this.handleAddMailItem(val) // 添加历史记录
        const data = await getQueryMailDetail({ mailNo: this.searchVal })
        if (data && data.code === '000000') {
          if (!data.info.length) { // 查无物流信息
            this.showState = 3
            return
          }
          // 跳转到详情页
          this.$store.commit('mailInfo/setMailInfo', data.info)
          this.$router.push(`/queryDetail/${val}`)
        } else if (data && data.code === '100011') { // 非优先邮
          this.showState = 2
        } else {
          this.showState = -1
          Toast((data && data.msg) || '系统开小差，请稍后再试')
        }
      }
    },
    handleAddMailItem (val) {
      let mailList = localStorage.mailList || []
      let mArr = JSON.parse(mailList)
      mArr.unshift(val)
      let temp = Array.from(new Set(mArr))
      mailList = JSON.stringify(temp)
      localStorage.mailList = mailList
      this.mailInput.mailList = JSON.parse(mailList)
      // 若历史记录中有val，将此val保存到最顶部
      // const index = this.mailInput.mailList.indexOf(val)
      // if (index !== -1) {
      //   this.mailInput.mailList.splice(index, 1)
      // }
      // this.mailInput.mailList.unshift(val)
      // localStorage.mailList = JSON.stringify(this.mailInput.mailList)
    },
    handleDelMailItem (index, item) { // 删除历史记录的某一条
      let temp = new Set(this.mailInput.mailList) // 转成set类型 不用查找直接删除
      temp.delete(item)
      this.mailInput.mailList = Object.assign([], Array.from(temp)) // 转回数组
      if (!this.mailInput.mailList.length) { // 如果是最后一条被删除 那么localStorage存为空数组
        localStorage.mailList = '[]'
        this.showState = -1
      } else {
        localStorage.mailList = JSON.stringify( // 否则就更新localStorage的数据
          Array.from(new Set(this.mailInput.mailList))
        )
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.query-page {
  height: 100vh;
  background-color: #f7f7f7;
}

.mail-query {
  display: flex;
  padding: torem(7px) 0;
  background-color: #fff;

  .mail-item {
    position: relative;
    width: 100%;
    height: torem(36px);
    margin: 0 torem(10px);
    background-color: #f7f7f7;
    border-radius: torem(18px);
    line-height: torem(40px);

    .scan-input {
      position: absolute;
      left: torem(18px);
      display: inline-block;
      color: #000;
      font-size: torem(20px);
    }

    .close {
      position: absolute;
      right: torem(22px);
      width: torem(16px);
      height: torem(16px);
      margin: torem(10px) 0;
    }

    input {
      position: absolute;
      top: torem(6px);
      left: torem(40px);
      width: 80%;
      margin: 0 torem(5px);
      background-color: #f7f7f7;
      font-size: torem(14px);
      line-height: torem(24px);

      &:focus {
        outline: none;
      }
    }
  }

  .confirm-btn {
    width: 2rem;
    align-items: center;
    margin: torem(8px) torem(23px) 0 0;
    color: #f08300;
    font-size: torem(14px);
  }
}

.mail-list {
  // position: absolute;
  // z-index: 1000;
  overflow: auto;
  width: 100%;
  // min-height: 32%;
  // max-height: calc(100% - 3rem);
  height: 100%;
  padding: torem(8px) 0 0 0;
  background-color: #fff;
  background-position: center;
  background-repeat: no-repeat;
  // 历史记录
  .mail-history {
    overflow: auto;
    max-height: torem(450px);
    padding-right: torem(16px);
    margin-left: torem(30px);

    .mail-list-item {
      display: flex;
      justify-content: space-between;
      padding: torem(8px) 0;
      line-height: torem(20px);

      .close {
        width: torem(14px);
        height: torem(14px);
        margin-top: torem(4px);
      }

      span {
        font-size: torem(14px);
      }
    }
  }

  .mail-list-last {
    padding: torem(10px);
    color: #9b9b9b;
    font-size: torem(14px);
    text-align: center;
  }
  //非优先邮,无物流信息
  .mail-list-center {
    width: 100%;
    height: 100%;
    background-color: #f7f7f7;

    .not-page {
      height: 100%;
      color: #f08300;
      text-align: center;

      .not-page-img {
        width: torem(315px);
        height: torem(180px);
      }

      .not-page-img2 {
        width: torem(123px);
        margin-top: torem(120px);
      }

      .not-page-msg {
        width: 100%;
        margin-top: torem(5px);
        font-size: torem(12px);
      }

      .color-gray {
        color: #9b9b9b;
      }
    }
  }
}

.tips {
  position: absolute;
  bottom: torem(40px);
  width: 100%;
  width: 100%;
  margin-top: torem(10px);
  color: #c0b7ad;
  font-size: torem(12px);
  font-weight: 400;
  text-align: center;

  a {
    color: #c0b7ad;
  }
}
</style>
